import script from "./UiInfoButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UiInfoButton.vue?vue&type=script&setup=true&lang=js"

import "./UiInfoButton.vue?vue&type=style&index=0&id=53b19a31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b19a31"]])

export default __exports__